import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/dev/coverage");

export const Route = createFileRoute("/dev/coverage")({
  head: () => ({
    meta: [
      { title: "Route coverage — LevelLoad" },
      { name: "description", content: "Route coverage — LevelLoad transport planning." },
      { property: "og:title", content: "Route coverage — LevelLoad" },
      { property: "og:description", content: "Route coverage — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
